import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRightIcon } from 'lucide-react';
import { Logo } from './Logo';
import { QuickLinks } from '../QuickLinks';
import { contact, hoursDisclaimer, openingHours } from '../../data/site';
type FooterProps = {
  showQuickLinks?: boolean;
};
export function Footer({
  showQuickLinks = true
}: FooterProps) {
  return <footer className="border-t border-ink-line bg-ink" data-id="element-81" data-mp="nzjm2zssi15">
      {showQuickLinks && <div className="border-b border-ink-line py-16" data-id="element-82" data-mp="q2gn6zdbbfd">
          <p className="mx-auto mb-12 max-w-3xl px-6 text-center font-script text-2xl italic text-white md:text-3xl" data-id="element-83" data-mp="3s1m29hwxhzej">
            Give your skin a treat, with the Best Artists Las Vegas has to offer!
          </p>
          <QuickLinks compact data-id="element-84" data-mp="3j3jvelqikcjc" />
        </div>}

      <div className="mx-auto grid max-w-6xl gap-12 px-6 py-16 md:grid-cols-[1.2fr_1fr_1fr]" data-id="element-85" data-mp="3e2mesdl5jqjy">
        <section aria-labelledby="footer-hours" data-id="element-86" data-mp="3942sud6k6erl">
          <h2 id="footer-hours" className="font-slab text-sm font-bold uppercase tracking-[0.25em]" data-id="element-87" data-mp="394b6w8ef3q4d">
            Opening Hours
          </h2>
          <dl className="mt-6 divide-y divide-ink-line border-y border-ink-line" data-id="element-88" data-mp="2p3teuallkhbz">
            {openingHours.map(row => <div key={row.day} className="flex items-center justify-between py-2.5" data-id="element-89" data-mp="2bd7t8e4rdtae">
                <dt className="font-slab text-xs font-bold uppercase tracking-[0.2em] text-ink-muted" data-id="element-90" data-mp="2gazva0z4avsb">{row.day}</dt>
                <dd className="font-slab text-sm tracking-wider" data-id="element-91" data-mp="340u487gbg07a">{row.hours}</dd>
              </div>)}
          </dl>
          <p className="mt-5 text-sm leading-relaxed text-ink-muted" data-id="element-92" data-mp="3825ri6bpw9cb">{hoursDisclaimer}</p>
        </section>

        <section aria-labelledby="footer-visit" data-id="element-93" data-mp="2u2o8y8p0lsbe">
          <h2 id="footer-visit" className="font-slab text-sm font-bold uppercase tracking-[0.25em]" data-id="element-94" data-mp="2z1hixr53f16t">
            Visit the Shop
          </h2>
          <address className="mt-6 space-y-4 not-italic leading-relaxed text-ink-muted" data-id="element-95" data-mp="1imfzrof2viqr">
            <p data-id="element-96" data-mp="1nof5v627ctre">
              <span className="text-white" data-id="element-97" data-mp="1nkra009abv9i">{contact.addressLine1}</span>
              <br data-id="element-98" data-mp="13jfzx06kezx8" />
              {contact.addressLine2}
              <br data-id="element-99" data-mp="zje7ziqmtkv5" />
              {contact.addressNote}
            </p>
            <p data-id="element-100" data-mp="zl8s4uu2x8y6">
              Call{' '}
              <a href={`tel:${contact.phoneMain}`} className="text-white hover:underline" data-id="element-101" data-mp="urw3ikpeh25f">
                {contact.phoneMain}
              </a>
              <br data-id="element-102" data-mp="pt2rkwprhj7d" />
              Walk-ins{' '}
              <a href={`tel:${contact.phoneWalkIn}`} className="text-white hover:underline" data-id="element-103" data-mp="kurgkinqd2nk">
                {contact.phoneWalkIn}
              </a>
              <br data-id="element-104" data-mp="fttzyaidcgo6" />
              Text{' '}
              <a href={`sms:${contact.phoneText}`} className="text-white hover:underline" data-id="element-105" data-mp="bta1n3m2770g">
                {contact.phoneText}
              </a>
            </p>
            <p data-id="element-106" data-mp="6wba8sts5e5y">
              <a href={`mailto:${contact.email}`} className="text-white hover:underline" data-id="element-107" data-mp="6wthsllw7et6">
                {contact.email}
              </a>
            </p>
          </address>
        </section>

        <section aria-labelledby="footer-follow" data-id="element-108" data-mp="216f21qg1102i">
          <h2 id="footer-follow" className="font-slab text-sm font-bold uppercase tracking-[0.25em]" data-id="element-109" data-mp="28qzc3amolqeg">
            Stay in the Loop
          </h2>
          <p className="mt-6 leading-relaxed text-ink-muted" data-id="element-110" data-mp="2dp0t7q0jrfna">
            Text <span className="font-medium text-white" data-id="element-111" data-mp="2ij51qdpgnvqh">‘START’</span> to{' '}
            <a href={`sms:${contact.phoneMain}?body=START`} className="text-white hover:underline" data-id="element-112" data-mp="2nh6k0wf2br0w">
              (702) 605-6633
            </a>{' '}
            to subscribe to our text message list.
          </p>
          <ul className="mt-6 flex flex-wrap gap-2" data-id="element-113" data-mp="1utapnycyub7a">
            {[{
            href: contact.instagram,
            label: 'Instagram'
          }, {
            href: contact.facebook,
            label: 'Facebook'
          }, {
            href: contact.youtube,
            label: 'YouTube'
          }].map(({
            href,
            label
          }) => <li key={label} data-id="element-114" data-mp="3b5g2ppgzbynt">
                <a href={href} target="_blank" rel="noreferrer" className="inline-flex items-center gap-1.5 border border-ink-line px-3 py-2 font-slab text-[11px] font-bold uppercase tracking-[0.2em] transition-colors duration-150 ease-out hover:border-white hover:bg-white hover:text-ink" data-id="element-115" data-mp="3b680n6y1u8h9">
                  {label}
                  <ArrowUpRightIcon className="h-3 w-3" aria-hidden="true" data-id="element-116" data-mp="3nn0mpvnlubw5" />
                </a>
              </li>)}
          </ul>
        </section>
      </div>

      <div className="border-t border-ink-line" data-id="element-117" data-mp="j2tctgwjj48">
        <div className="mx-auto flex max-w-6xl flex-col items-center justify-between gap-4 px-6 py-6 text-xs text-ink-faint sm:flex-row" data-id="element-118" data-mp="3rqot4b0i31ft">
          <Link to="/" className="flex items-center gap-3" data-id="element-119" data-mp="a95mcto0wx2k">
            <Logo className="h-10 w-10" data-id="element-120" data-mp="5b476jtpxhwd" />
            <span className="font-slab font-bold uppercase tracking-[0.2em] text-white" data-id="element-121" data-mp="5cf7uarva9j9">Trip Ink Tattoo</span>
          </Link>
          <p data-id="element-122" data-mp="jb57ny62mnbb">© {new Date().getFullYear()} Trip Ink Tattoo Company · Las Vegas, NV</p>
        </div>
      </div>
    </footer>;
}